export default "__VITE_ASSET__CYjclJy9__"